import constant from "lodash/constant";
import { FilteredGraphWrapper } from "yfiles";
export default (graphComponentRef, graphAdapterRef, presentationInterval) => {
    if (!graphComponentRef.current || !graphAdapterRef.current)
        return;
    const wrapper = new FilteredGraphWrapper(graphAdapterRef.current.originalGraph, node => {
        var _a;
        if (!presentationInterval)
            return true;
        const created = (_a = node.tag) === null || _a === void 0 ? void 0 : _a.Created;
        return (!created || (created >= presentationInterval.from && created <= presentationInterval.to));
    }, constant(true));
    graphComponentRef.current.graph = wrapper;
};
